import ActionsForm from '@/shared/mixins/actionsForm'
import documentsmanagement from '@/shared/http/repositories/realestate/documentsmanagement'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default{
  mixins: [ActionsForm],
  name: 'TableDocuments',
  data () {
    return {
      headTable: ['DOCUMENTO', 'EMPREENDIMENTO / CLIENTE', 'DATA DE ENVIO', ''],
      documentsArray: [],
      isFilter: false,
      filter: localStoreHelper.gestao.documento() || {}
    }
  },
  methods: {
    verificaLocalStoreHelper () {
      this.isFilter = localStoreHelper.gestao.documento() != null ? 1 : false
    },
    onLoad () {
      this.verificaLocalStoreHelper()
      if (this.isFilter) {
        documentsmanagement.GetDocumentosByFiltro(this.$refs.tableDocuments.pagingLimit, this.$refs.tableDocuments.pagingIndex, this.filter)
          .then(res => {
            if (res.status === 200) {
              let newDocumentsArray = res.data.data
              let newResponse = res
              this.documentsArray = newDocumentsArray
              this.$refs.tableDocuments.LoadAllByData(newResponse)
            }
          })
          .catch(res => console.log(res))
        return
      }
      documentsmanagement.GetAllDocumentos(this.$refs.tableDocuments.pagingLimit, this.$refs.tableDocuments.pagingIndex)
        .then(res => {
          this.documentsArray = res.data.data
          this.$refs.tableDocuments.LoadAllByData(res)
        })
        .catch(err => console.log(err))
    },
    onDownloadDocument (fileId) {
      documentsmanagement.DownloadDocumento(fileId)
        .then(res => {
          if (res.status === 200) {
            let dataResponse = res.data.data

            const linkDownload = document.createElement('a')
            linkDownload.href = `data:image/png;base64,${dataResponse.arquivo.arquivo}`
            linkDownload.download = `${dataResponse.arquivo.descricao}.${dataResponse.arquivo.extensao}`
            linkDownload.click()
            URL.revokeObjectURL(linkDownload.href)
          }
        })
        .catch(err => console.log(err))
    },
    searchWithFilter (filter, isFilter) {
      this.isFilter = isFilter
      this.filter = filter
      if (!this.isFilter) {
        this.$refs.tableDocuments.pagingIndex = 1
        this.$refs.tableDocuments.currentPage = 1
      }
      documentsmanagement.GetDocumentosByFiltro(this.$refs.tableDocuments.pagingLimit, this.$refs.tableDocuments.pagingIndex, filter)
        .then(res => {
          if (res.status === 200) {
            let newDocumentsArray = res.data.data
            let newResponse = res
            this.documentsArray = newDocumentsArray
            this.$refs.tableDocuments.LoadAllByData(newResponse)
          }
        })
        .catch(res => console.log(res))
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/documentsManagement/components/TableDocuments/TableDocuments.js